import React from 'react';
import InfoBox from '../../../../widgets/InfoBox/InfoBox';
import PropTypes from 'prop-types';
import Subheader from 'material-ui/Subheader';
import { Icon, Paper } from '@material-ui/core';
import {
  AssignmentTurnedIn,
  EventBusy,
  SupervisorAccount
} from '@material-ui/icons';
import './DashboardPage.css';
import RenewalsActionPanel from '../../../../presenters/renewals/dashboard/RenewalsActionPanel/RenewalsActionPanel';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { RENEWALS_PORTAL_URL } from '../../../../../route-names';
import { injectIntl } from 'react-intl';

const DashboardPage = (props) => {
  return (
    <Paper style={{ margin: 15 }}>
      <Subheader className="dashboard-section-subheader">
        <Icon>assignment</Icon>
        {props.intl.formatMessage({
          id: 'renewals'
        })}
      </Subheader>
      <div className="main-paper-layout">
        <div className="row info-boxes">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 m-b-15">
            <Link
              to={`${RENEWALS_PORTAL_URL}?statuses=APPROVAL_REQUIRED&title=${props.intl.formatMessage(
                {
                  id: 'customer_table_approval_required.title'
                }
              )}`}
            >
              <InfoBox
                icon={
                  <AssignmentTurnedIn
                    style={{ color: '#ecbb43' }}
                    className="icon-box-icon-image material-icons"
                  />
                }
                color="#F0AB00"
                title={props.intl.formatMessage({
                  id: 'requiring_approval.title'
                })}
                value={props.renewalsRequiringActionCount}
              />
            </Link>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 m-b-15">
            <Link
              to={`${RENEWALS_PORTAL_URL}?statuses=CUSTOMER_APPROVAL_REQUIRED&title=${props.intl.formatMessage(
                {
                  id: 'customer_table_awaiting_customer_signature.title'
                }
              )}`}
            >
              <InfoBox
                icon={
                  <SupervisorAccount
                    style={{ color: '#7095b6' }}
                    className="icon-box-icon-image material-icons"
                  />
                }
                color="#5482AB"
                title={props.intl.formatMessage({
                  id: 'exceptions_awaiting_customer_signature.title'
                })}
                value={props.renewalsAwaitingSignatureCount}
              />
            </Link>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 m-b-15">
            <Link
              to={`${RENEWALS_PORTAL_URL}?contractExpiresBefore=${moment()
                .startOf('d')
                .format('Y-MM-DD')}&title=${props.intl.formatMessage({
                id: 'customer_table_past_due.title'
              })}`}
            >
              <InfoBox
                icon={
                  <EventBusy
                    style={{ color: '#cb3753' }}
                    className="icon-box-icon-image material-icons"
                  />
                }
                color="#C60C30"
                title={props.intl.formatMessage({
                  id: 'renewal_past_due'
                })}
                value={props.renewalsPastDueCount}
              />
            </Link>
          </div>
        </div>
      </div>
      {!!props.customersRequiringAction ? (
        <RenewalsActionPanel customers={props.customersRequiringAction} />
      ) : null}
    </Paper>
  );
};

DashboardPage.propTypes = {
  renewalsRequiringActionCount: PropTypes.number,
  renewalsAwaitingSignatureCount: PropTypes.number,
  renewalsPastDueCount: PropTypes.number
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default injectIntl(connect(mapStateToProps)(DashboardPage));
